import React from 'react'
import Footer from '../Home/Footer'
import ReactHTMLParser from 'react-html-parser'

export default (props) => (
  <div style={props.style} id="interview-container">
    <header className="l-header l-header-lower interview-header">
      <div className="header-bg" />
      <div className="header-wrap">
        <div className="header-return"><a onClick={props.backToHome}>
            <svg className="svgIllust" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
              <title />
              <path d="M333.653,41.349H48.769c-7.187,0-13.031,5.848-13.031,13.027v62.129c0,7.184,5.844,13.028,13.031,13.028h286.223c45.484,0,84.328,34.156,88.43,77.758c2.313,24.539-5.516,48.051-22.039,66.199c-16.305,17.918-39.508,28.191-63.645,28.191H199.769V230.76c0-5.386-4.382-9.77-9.774-9.77c-1.859,0-3.683,0.531-5.25,1.539L4.523,337.525C1.695,339.322,0.004,342.4,0,345.752c-0.004,3.352,1.684,6.434,4.512,8.242L184.75,469.119c1.574,1.004,3.39,1.532,5.246,1.532c5.391,0,9.774-4.383,9.774-9.77v-71.016h137.969c47.727,0,92.294-18.988,125.489-53.465c33.176-34.45,50.449-79.73,48.645-127.504C508.379,116.509,428.43,41.349,333.653,41.349z" />
            </svg></a></div>
        {/* <nav className="header-nav">
          <ul>
            <li className="entry"><a target="_blank" href={props.formUrl} rel="noopener noreferrer">ENTRY</a></li>
          </ul>
        </nav> */}
      </div>
    </header>
    <main className="l-main theme-single">
      <article className="l-article">
        <section className="interviews_lower">
          <div className="interviews_lower_first background-interview">
            <div className="section_hexagon" />
            <div className="section_contents">
              <div className="visual_group">
								<div className="visual interview-img" style={{
                  visibility: 'hidden'
                }}>
                  <img src="" alt="" />
                </div>
                { props.data.point &&
                  <div className="point _pc">
                    <img src={`images/interviews/${props.data.point.visual}.webp`} alt="" />
                    <p>{ReactHTMLParser(props.data.point.text)}</p>
                  </div>
                }
							</div>
              <div className="textarea">
                <p className="title animation-text-top"><strong>{ReactHTMLParser(props.data.first.title)}</strong></p>
                <div className="info">
                  <div className="name">
                    <h3>{props.data.first.name}</h3>
                  </div>
                  <div className="job interview-job">{props.data.first.job}</div>
                  <div className="box">
                    <div className="day">{props.data.first.year}</div>
                    <div className="career">{props.data.first.career}</div>
                  </div>
                </div>
                <p className="subtitle animation-text-top"><strong>{ReactHTMLParser(props.data.first.subtitle)}</strong></p>
                <p className="text animation-text-bottom">{ReactHTMLParser(props.data.first.text)}</p>
              </div>
            </div>
          </div>
          <div className="interviews_lower_second">
            <div className="group">
              <div className="visual">
                <img src={`images/interviews/${props.data.second.visual}.webp`} alt="" />
              </div>
              <div className="textarea">
                <p className="subtitle"><strong>{ReactHTMLParser(props.data.second.subtitle)}</strong></p>
                <p className="text">{ReactHTMLParser(props.data.second.text)}</p>
              </div>
            </div>
            <div className="group is-revers">
              <div className="visual">
                <img src={`images/interviews/${props.data.third.visual}.webp`} alt="" />
              </div>
              <div className="textarea">
                <p className="subtitle"><strong>{ReactHTMLParser(props.data.third.subtitle)}</strong></p>
                <p className="text">{ReactHTMLParser(props.data.third.text)}</p>
              </div>
            </div>
          </div>
          <div className="interviews_lower_third">
            <div className="title">
              <p>とある１日のスケジュール</p>
            </div>
            <div className="dayflow">
              <div className="item">
                <div className="icon-brackets">
                  <p className="time">{ReactHTMLParser(props.data.flow.time_1)}</p>
                  <p className="text">{ReactHTMLParser(props.data.flow.text_1)}</p>
                </div>
              </div>
              <div className="item">
                <div className="icon-brackets">
                  <p className="time">{ReactHTMLParser(props.data.flow.time_2)}</p>
                  <p className="text">{ReactHTMLParser(props.data.flow.text_2)}</p>
                </div>
              </div>
              <div className="item">
                <div className="icon-brackets">
                  <p className="time">{ReactHTMLParser(props.data.flow.time_3)}</p>
                  <p className="text">{ReactHTMLParser(props.data.flow.text_3)}</p>
                </div>
              </div>
              <div className="item">
                <div className="icon-brackets">
                  <p className="time">{ReactHTMLParser(props.data.flow.time_4)}</p>
                  <p className="text">{ReactHTMLParser(props.data.flow.text_4)}</p>
                </div>
              </div>
              <div className="item">
                <div className="icon-brackets">
                  <p className="time">{ReactHTMLParser(props.data.flow.time_5)}</p>
                  <p className="text">{ReactHTMLParser(props.data.flow.text_5)}</p>
                </div>
              </div>
              <div className="item">
                <div className="icon-brackets">
                  <p className="time">{ReactHTMLParser(props.data.flow.time_6)}</p>
                  <p className="text">{ReactHTMLParser(props.data.flow.text_6)}</p>
                </div>
              </div>
              <div className="item">
                <div className="icon-brackets">
                  <p className="time">{ReactHTMLParser(props.data.flow.time_7)}</p>
                  <p className="text">{ReactHTMLParser(props.data.flow.text_7)}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="interviews_lower_remote">
            <div className="contents">
              <div className="title">LYZONのリモートワークについて</div>
              <div className="text">{ReactHTMLParser(props.data.remote.text)}</div>
              <div className="small">※インタビュー内容は2022年取材当時のものです。</div>
            </div>
          </div>
          <div className="interviews_lower_return">
            <div className="return"><a onClick={props.backToHome}>
                <svg className="svgIllust" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                  <title />
                  <path d="M333.653,41.349H48.769c-7.187,0-13.031,5.848-13.031,13.027v62.129c0,7.184,5.844,13.028,13.031,13.028h286.223c45.484,0,84.328,34.156,88.43,77.758c2.313,24.539-5.516,48.051-22.039,66.199c-16.305,17.918-39.508,28.191-63.645,28.191H199.769V230.76c0-5.386-4.382-9.77-9.774-9.77c-1.859,0-3.683,0.531-5.25,1.539L4.523,337.525C1.695,339.322,0.004,342.4,0,345.752c-0.004,3.352,1.684,6.434,4.512,8.242L184.75,469.119c1.574,1.004,3.39,1.532,5.246,1.532c5.391,0,9.774-4.383,9.774-9.77v-71.016h137.969c47.727,0,92.294-18.988,125.489-53.465c33.176-34.45,50.449-79.73,48.645-127.504C508.379,116.509,428.43,41.349,333.653,41.349z" />
                </svg></a></div>
          </div>
        </section>
      </article>
    </main>
    <Footer isModalFooter={true} />
  </div>
)


// WEBPACK FOOTER //
// ./src/Interview/Container.js